import PropTypes from 'prop-types';

import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const ForgotPasswordFormDefaultProps = {
  ...IsLoadingDefaultProps,
};

export const ForgotPasswordFormPropTypes = {
  ...IsLoadingPropTypes,
  onSuccess: PropTypes.func,
};

export const ForgotPasswordFormContainerDefaultProps = {
  ...IsLoadingDefaultProps,
};

export const ForgotPasswordFormContainerPropTypes = {
  ...IsLoadingPropTypes,
  onSuccess: PropTypes.func,
};
